var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticStyle:{"min-height":"100vh"}},[_c('HeaderPanel'),_c('div',{staticClass:"flex relative"},[_c('sidebar'),_c('div',{staticClass:"main-wrapper w-[calc(100%-110px)]"},[_c('router-view')],1)],1)],1),_c('GlobalLoaderIndicator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }